import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { SEO, breadcrumbSchema } from "../components/SEO";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Reveal } from "../components/Reveal";
import { ContactForm } from "../components/ContactForm";
import { business } from "../content/site";
import { trackEvent } from "../lib/analytics";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

export default function Contact() {
  const c = useCopy("contact");
  const cr = useCopy("crumbs");
  const lp = useLp();
  const crumbs = [
    { name: cr.home, path: lp("/") },
    { name: cr.contact, path: lp("/contacto/") },
  ];
  return (
    <>
      <SEO
        title={c.seoT}
        description={c.seoD}
        path="/contacto/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <Breadcrumbs items={crumbs} />
      <section className="container-site section-gap !pt-10" data-testid="contact-page">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="tech-label mb-4">{c.kicker}</p>
              <h1 className="text-3xl sm:text-4xl font-bold leading-tight">{c.h1}</h1>
              <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                {c.intro}
              </p>
            </Reveal>
            <Reveal delay={0.1} className="mt-10 space-y-1 border hairline rounded-sm divide-y divide-slate-200 bg-white max-w-md">
              <a href={business.phoneHref} onClick={() => trackEvent("phone_click", { location: "contact" })}
                 data-testid="contact-phone" className="flex items-center gap-4 p-5 hover:bg-paper-tint transition-colors">
                <Phone size={18} className="text-terracotta shrink-0" aria-hidden="true" />
                <span>
                  <span className="block text-xs text-slate-600">{c.phoneL}</span>
                  <span className="font-mono text-sm text-ink">{business.phoneDisplay}</span>
                </span>
              </a>
              <a href={business.whatsappUrl} target="_blank" rel="noopener noreferrer"
                 onClick={() => trackEvent("whatsapp_click", { location: "contact" })}
                 data-testid="contact-whatsapp" className="flex items-center gap-4 p-5 hover:bg-paper-tint transition-colors">
                <MessageCircle size={18} className="text-terracotta shrink-0" aria-hidden="true" />
                <span>
                  <span className="block text-xs text-slate-600">WhatsApp</span>
                  <span className="font-mono text-sm text-ink">{c.whatsNote}</span>
                </span>
              </a>
              <a href={`mailto:${business.email}`} onClick={() => trackEvent("email_click", { location: "contact" })}
                 data-testid="contact-email" className="flex items-center gap-4 p-5 hover:bg-paper-tint transition-colors">
                <Mail size={18} className="text-terracotta shrink-0" aria-hidden="true" />
                <span>
                  <span className="block text-xs text-slate-600">{c.emailL}</span>
                  <span className="font-mono text-sm text-ink">{business.email}</span>
                </span>
              </a>
              <div className="flex items-center gap-4 p-5">
                <MapPin size={18} className="text-terracotta shrink-0" aria-hidden="true" />
                <span>
                  <span className="block text-xs text-slate-600">{c.areaL}</span>
                  <span className="text-sm text-ink">{c.areaV}</span>
                </span>
              </div>
            </Reveal>
            <Reveal delay={0.15} className="mt-8 max-w-md">
              <img src="/contacto-estudio.jpg" alt={c.photoAlt} data-testid="contact-photo"
                   className="w-full h-auto rounded-sm border hairline" loading="lazy" />
            </Reveal>
            <p className="mt-5 text-xs text-slate-600 max-w-md leading-relaxed">
              {c.refNote}
            </p>
          </div>
          <Reveal delay={0.15} className="lg:col-span-7">
            <div className="bg-white border hairline rounded-sm p-6 sm:p-10">
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
